//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import { findIndex, cloneDeep } from 'lodash'
import ProjectTokenCard from '~/components/ProjectTokenCard.vue'
import SellTokensDialog from '~/components/SellTokensDialog.vue'

export default {
  components: {
    ProjectTokenCard,
    SellTokensDialog,
  },
  props: {
    project: {
      type: Object,
      default: null,
    },
    showSampleTokens: {
      type: Function,
      default: null,
    }
  },
  data() {
    return {
      tokens: [],
      total: 0,
      limit: 20,
      offset: 0,
      sort: 'listed-desc',
      sortOptions: [
        { text: 'Token ID', value: 'token_id-asc' },
        { text: 'Rarity: Most to Least', value: 'rarity-asc' },
        { text: 'Rarity: Least to Most', value: 'rarity-desc' },
        { text: 'Price: Low to High', value: 'price-asc' },
        { text: 'Price: High to Low', value: 'price-desc' },
        { text: 'Recently Listed', value: 'listed-desc' },
        // { text: 'Recently Sold', value: 'sold-desc' },
        { text: 'Oldest', value: 'oldest-asc' },
      ],
      filters: [],
      filterOptions:[ 
        {
          text: 'Status', 
          Options: [
              { text: 'For Sale', value: 'buy-now' },
              { text: 'My Listings', value: 'my-listings' },
              { text: 'Revealed', value: 'revealed' },
              { text: 'Not Revealed', value: 'not-revealed' }
            ]
        }
      ],
      loading: false,
      panels: [0],
      showFilters: false,
      showFiltersMobile: false
    }
  },
  computed: {
    ...mapState(['userAddress', 'marketOptions']),
  },
  watch: {
    sort() {
      this.reloadTokens()
    },
    filters() {
      this.reloadTokens()
    },
    showFiltersMobile(e) {
      // fix to prevent overlapping scrollbar for the mobile filters drawer
      if (e) {
        document.querySelector("html").style.overflowY = "hidden"
      }
      else {
        document.querySelector("html").style.overflowY = "scroll"
      }
    }
  },
  async mounted() {
    // await this.loadTokens()
    await this.loadOptions()
    this.sort = this.marketOptions.sort
    this.filters =  this.marketOptions.filters
  },
  methods: {
    reloadTokens() {
      this.offset = 0
      this.tokens.length = 0
      this.loadTokens()
    },
    async loadTokens() {
      try {
        if (!this.project.id) {
          await new Promise((resolve) => setTimeout(resolve, 1000))
          await this.loadTokens()
        }
        if (this.loading) {
          return
        }
        this.loading = true
        this.$store.dispatch('setMarketOptions', {sort: this.sort, filters: this.filters})
        const request = {
          method: 'GET',
          url: `/api/tokens/market`,
          params: {
            limit: this.limit,
            offset: this.offset,
            projectId: this.project.id,
            include: ['token'],
            sortBy: this.sort.split('-')[0],
            sortDir: this.sort.split('-')[1],
            filters: this.filters.map(f => f.value),
            wallet: this.userAddress,
          },
        }
        const resp = await this.$axios(request)
        this.tokens.push(...resp.data.tokens)
        this.total = resp.data.total
        this.loading = false
      } catch (err) {
        this.loading = false
        console.error(err)
      }
    },
    async infiniteScrolling(entries, observer, isIntersecting) {
      if (
        (this.total > 0 && this.tokens.length === this.total) ||
        this.loading
      ) {
        return
      }
      await new Promise((resolve) => setTimeout(resolve, 500))
      this.offset = this.tokens.length
      await this.loadTokens()
    },
    async loadOptions() {
      try {
        this.loading = true
        const request = {
          method: 'GET',
          url: `/api/projects/${this.project.slug}/options`,
        }
        const resp = await this.$axios(request)
        const options =
          resp.data.Layers.
            map(o => {return {text: o.name, Options: o.Options.
              map(a => {return {text: a.nicename, value: a.id, counter: a.counter
              }})
            }})
        this.filterOptions = this.filterOptions.concat(options)
        this.loading = false
      } catch (err) {
        this.loading = false
        console.error(err)
      }
    },
    purchased(token) {
      const idx = findIndex(this.tokens, (t) => t.id === token.id)
      if (idx > -1) {
        this.tokens.splice(idx, 1)
      } else {
        console.error('Unable to find token in list:', token)
      }
    },
    remove(index) {
      const temp = cloneDeep(this.filters)
      temp.splice(index, 1)
      this.filters = temp
    },
  },
}
